// Static, non-translatable site data (real B.health team, services, offers).
import {
  HeartPulse, Bone, Footprints, Brain, HandHeart, Apple, Dumbbell, Users,
} from "lucide-react";

// Real team members from bhealth.be (name, role per language, phone, photo)
export const TEAM = [
  { name: "Emilie", role: { fr: "Kinésithérapeute", en: "Physiotherapist", nl: "Kinesitherapeut" }, phone: "+32 479 76 49 88", img: "/img/team-emilie.jpg" },
  { name: "Jade", role: { fr: "Kinésithérapeute", en: "Physiotherapist", nl: "Kinesitherapeut" }, phone: "+32 456 94 10 93", img: "/img/team-jade.jpg" },
  { name: "Maxime", role: { fr: "Kinésithérapeute", en: "Physiotherapist", nl: "Kinesitherapeut" }, phone: "+32 497 24 01 43", img: "/img/team-maxime.jpg" },
  { name: "Simon", role: { fr: "Ostéopathe", en: "Osteopath", nl: "Osteopaat" }, phone: "+32 492 86 43 41", img: "/img/team-simon.png" },
  { name: "Isabelle", role: { fr: "Massage bien-être", en: "Wellness massage", nl: "Wellnessmassage" }, phone: "+32 498 03 76 30", img: "/img/team-isabelle.jpg" },
  { name: "Jean-Philippe", role: { fr: "Nutrition « Glyco-Coaching »", en: "Nutrition 'Glyco-Coaching'", nl: "Voeding 'Glyco-Coaching'" }, phone: "+32 478 50 08 62", img: "/img/team-jeanphilippe.jpg" },
  { name: "Julie", role: { fr: "Réflexologie plantaire", en: "Foot reflexology", nl: "Voetreflexologie" }, phone: "+32 476 20 81 73", img: "/img/team-julie.jpg" },
  { name: "Céline", role: { fr: "Sophrologue", en: "Sophrologist", nl: "Sofroloog" }, phone: "+32 475 60 43 90", img: "/img/team-celine.jpg" },
];

// Restart profile cards (key matches backend profile keys)
export const PROFILE_CARDS = [
  { key: "energie", icon: HeartPulse, img: "/img/profile-energie.jpg" },
  { key: "poids", icon: Apple, img: "/img/profile-poids.jpg" },
  { key: "mobilite", icon: Bone, img: "/img/profile-mobilite.jpg" },
  { key: "performance", icon: Dumbbell, img: "/img/profile-performance.jpg" },
  { key: "longevite", icon: Footprints, img: "/img/profile-longevite.jpg" },
];

// "Pourquoi B.health" pillars
export const PILLARS = [
  { icon: HeartPulse, key: "why_p1" },
  { icon: Bone, key: "why_p2" },
  { icon: Brain, key: "why_p3" },
  { icon: HandHeart, key: "why_p4" },
  { icon: Dumbbell, key: "why_p5" },
  { icon: Users, key: "why_p6" },
];

// Offers (prices static, copy via i18n)
export const OFFERS = [
  { key: "offer_junior", price: "59€", featured: false },
  { key: "offer_adult", price: "69€", featured: true },
];

// Hero slideshow — inclusive set (mixed gender, ages, activities) crossfading every 5s.
export const HERO_IMAGES = [
  "/img/hero-1.jpg", // Groupe mixte hommes/femmes avec coach (extérieur)
  "/img/hero-2.jpg", // Femme grisonnante / senior, active
  "/img/hero-3.jpg", // Séance de groupe mixte (yoga / mobilité)
  "/img/hero-4.jpg", // Groupe de coureurs (énergie, jeunes)
  "/img/hero-5.jpg", // Personne active sur tapis de course (salle moderne)
];

export const HERO_IMG = HERO_IMAGES[0];

// Coaching team group photo (provided by client)
export const COACH_TEAM_IMG =
  "https://customer-assets.emergentagent.com/job_bhealth-restart/artifacts/zjzpjnpm_Capture%20d%E2%80%99e%CC%81cran%202026-06-08%20a%CC%80%2021.26.54.png";

// External coach access / subscription portal
export const COACH_PORTAL = "https://subscription-portal-16.emergent.host/inscription";

// Technogym B.health® mobile app — official store links
export const APP_STORE_URL = "https://apps.apple.com/be/app/technogym-app-fitness-sport/id976506047?l=fr-FR";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.technogym.tgapp&pcampaignid=web_share";

// Partner offers — B.health® Local Benefits (external cercle)
export const CERCLE_URL = "https://cercle-local-bhealth.emergent.host";

// Map embed + directions deep links (Avenue de la Basilique 14, 1082 Berchem-Sainte-Agathe)
export const MAP_EMBED =
  "https://www.google.com/maps?q=Avenue%20de%20la%20Basilique%2014%2C%201082%20Berchem-Sainte-Agathe&output=embed";
export const MAP_GMAPS =
  "https://www.google.com/maps/dir/?api=1&destination=Avenue%20de%20la%20Basilique%2014%2C%201082%20Berchem-Sainte-Agathe";
export const MAP_WAZE =
  "https://www.waze.com/ul?q=Avenue%20de%20la%20Basilique%2014%2C%201082%20Berchem-Sainte-Agathe&navigate=yes";

export const STUDIO_IMG = "/img/studio.jpg";

export const CONTACT = {
  address: "Avenue de la Basilique 14, 1082 Berchem-Sainte-Agathe",
  phone: "0493 33 33 62",
  phoneRaw: "+32493333362",
  email: "sante@bhealth.be",
  social: {
    facebook: "https://www.facebook.com/bsportshealth",
    instagram: "https://www.instagram.com/bsportshealth360/",
    tiktok: "https://www.tiktok.com/@bhealth1082",
    linkedin: "https://www.linkedin.com/company/b.sports/",
  },
};
